<template>
    <div class="export_report_box bg_fff">
        <div ref="reportBox">
            <div class="header">
                <p class="title fs24 co_fff font_6">{{ title }}</p>
                <p class="time fs11 co_fff">{{ timeStr }}</p>
            </div>
            <div>
                <ExportReportTitle :title="reportNavList[0]" index="0"></ExportReportTitle>
                <CurveChart v-if="fameHealthTrend"
                            :renderData="fameHealthTrend"
                            :content="healthTrendStr"
                            :entity="entityId"
                            :periodStr=periodStr
                            :hasLine="true"

                ></CurveChart>
                <SplitLine/>

                <div v-if="subEntityHealth">
                    <HealthTable title="子行业舆情健康指数"
                                 :periodStr=periodStr
                                 :renderData='subEntityHealth'
                                 :hasLine="true"
                    ></HealthTable>
                    <SplitLine/>
                </div>
                <!--   金融业 - 行业下企业健康度         -->
                <div v-if="general && entityType === 'industry'" >
                    <HealthRank
                        ref="healthRankRef"
                        :periodStr=periodStr
                        :renderData="general.companyCounts"
                        :entity="entityId"
                        :hasLine="true"/>
                    <SplitLine/>
                </div>
                <div class="mt20" v-if="spreadStats">
                    <div class="_box">
                        <VerticalLine title="传播影响力分布"/>
                        <p class="fs14 co_ff8 mt12" v-html="broadcastEffectStr"></p>
                    </div>
                    <PieChart
                        ref="broadcastEffectRef"
                        :renderData="spreadStats.broadcastEffect"
                        :isEffect="true"
                        chartShowEntityCountUnit="篇"
                        :onlyChart="true"/>
                </div>
                <EventStatsBar
                    v-if="spreadStats"
                    :renderData="spreadStats"
                    class="mb20"/>
                <!--     企业月报  重点事件     -->
                <div v-if="entityType == 'company' && periodStr === reportPeriodMap.month">
                    <SplitLine class="mt20"/>
                    <div class="_box mt20">
                        <VerticalLine title="重点事件"/>
                        <p class="fs14 co_ff8 mt12" v-html="reportDesc"></p>
                    </div>

                    <div class="mt28">
                        <div ref="companyNegImage">
                            <img class="article_icon ml16" src="../assets/img/icon/negativeTop5.png">
                            <ArticleList
                                :assignData="reportTop5.negative"
                                :onlyList="true"
                                timeKey="lastCreatedStr"
                                :noIndex="false"/>
                        </div>
                        <SplitLine class="mb12"/>
                        <div ref="companyPosImage">
                            <img class="article_icon ml16" src="../assets/img/icon/positiveTop5.png">
                            <ArticleList
                                :assignData="reportTop5.positive"
                                :assignPositive="true"
                                :onlyList="true"
                                timeKey="lastCreatedStr"
                                :noIndex="false"/>
                        </div>

                    </div>
                </div>
            </div>

            <div>
                <ExportReportTitle :title="reportNavList[1]" index="1"></ExportReportTitle>
                <div v-if="riskStats">
                    <BarChartCrosswise v-if="riskStats.yinbaoRiskCounts"
                                       ref="yinbaoRiskRef"
                                       title="风险概况"
                                       :hasLine="true"
                                       :hasChartTitleLine="true"
                                       :setContent="riskGeneralStr"
                                       :renderData="riskStats.yinbaoRiskCounts"
                                       :tagNum=10
                                       riskType="yinbaoRisk"
                                       :entityType="entityType"/>
<!--                    <div class="_box mt20" v-else>&lt;!&ndash; 兼容之前老数据 yinbaoRiskCounts&ndash;&gt;-->
<!--                        <VerticalLine title="风险概述"/>-->
<!--                        <p class="fs14 co_ff8 mt12" v-html="riskGeneralStr"></p>-->
<!--                    </div>-->
                    <SplitLine/>
                    <BarChartCrosswise ref="contentRiskRef" firstTitle="主要内容风险点"
                                       chartTitle="主要内容风险点"
                                       :renderData="riskStats.contentRisks"
                                       :onlyChart="true"
                                       :hasChartTitleLine="true"
                                       :entityType="entityType"
                                       :tagNum=10 />
                    <SplitLine class="mtb12"/>
                    <div class="_box">
                        <VerticalLine title="风险等级占比"/>
                        <p class="fs14 co_ff8 mt12" v-html="riskLevelStr"></p>

                        <PieChart
                          ref="riskLevelRef"
                          chartId="PieChartGeneral"
                          :onlyChart="true"
                          chartShowEntityCountUnit="件"
                          :renderData="riskStats.riskLevelCounts"/>
                    </div>
                </div>

            </div>

            <div class="view_port_box">
                <ExportReportTitle :title="reportNavList[2]" index="2"></ExportReportTitle>
                <div class="_box noRight mt20">
                    <VerticalLine title="渠道报道倾向"/>
                    <TendencyChart v-if="spreadStats" ref="tendencyChartRef" :periodStr=periodStr chart-box='industry'
                                   :channelStats='spreadStats.channelTendency' :entity="entityId" :entityType="entityType"/>
                </div>
                <SplitLine class="mt12"/>
                <MediaReports v-if="riskStats"
                      ref="mediaReportRef"
                      :periodStr=periodStr
                      tendency="negative"
                      :renderData='riskStats.hotMediaList'
                      :hasLine="true"
                      :entity="entityId"
                      :entityType="entityType"
                      :articleCount="negArticleCount"/>
                <!--  企业月报 下属企业舆情分布          -->
                <div v-if="subCompanySpreadStats">
                    <TendencyPercentBar v-if="subCompanySpreadStats" :renderData="subCompanySpreadStats" :hasLine="true"/>
                </div>

            </div>

            <div class="data_box">
                <!--     重大事件  企业 月报      -->
                <ExportReportTitle :title="reportNavList[3]" index="3"></ExportReportTitle>
                <div v-if="entityType == 'company' && periodStr === reportPeriodMap.month" class="_box mt20">
                    <div>
                        <VerticalLine title="事件概要"/>
                        <div v-if="mainEvent" ref="mainEventImage">
                            <a class="fs14 co_333 mt12" :href="mainEvent.uri" target="_blank"> {{ mainEvent.title }}。</a>
                            <div class="iconBox flex_box mt6">
                                <p class=" flex_box flex_wrap" v-if="mainEvent.tags_v2 && mainEvent.tags_v2.length ">
                                    <span class="commonTag fs10" v-for="(itemTag, tagIndex) in mainEvent.tags_v2"
                                          :key="itemTag.key + tagIndex"
                                          :class="(itemTag && itemTag.key === 'yinbao') ? 'yellowTag' : 'redTag' ">{{
                                            itemTag.value
                                        }}</span>
                                </p>
                                <p class=" flex_box flex_wrap" v-else>
                                    <span class="commonTag fs10" v-for="(itemTag, tagIndex) in mainEvent.tags"
                                          :key="itemTag + tagIndex"
                                          :class="(itemTag && tagIndex === 0) ? 'yellowTag' : 'redTag'">{{
                                            itemTag
                                        }}</span>
                                </p>
                            </div>
                            <SplitLine class="mt12"/>
                        </div>
                        <div v-else class="fs14 co_333 mt12">暂无重点事件</div>
                    </div>

                    <div class="mt12" v-show="soundTrends.length">
                        <SoundTrendChart
                            title="发文趋势"
                            :hasTitle="true"
                            :content="soundTrendStr"
                            :renderData="soundTrends"/>
                    </div>
                </div>

                <!--     焦点报道  企业 日报  + 行业 日报 && 月报      -->
                <div v-else class="mt28">
                  <div class="top_desc" v-html="reportDesc"></div>
                  <div ref="negImage">
                        <img class="article_icon ml16" src="../assets/img/icon/negativeTop5.png">
                        <ArticleList
                            :assignData="reportTop5.negative"
                            :onlyList="true"
                            timeKey="lastCreatedStr"
                            :noIndex="false"
                        ></ArticleList>
                    </div>
                    <SplitLine class="mb12"/>
                    <div ref="posImage">
                        <img class="article_icon ml16" src="../assets/img/icon/positiveTop5.png">
                        <ArticleList
                            :assignData="reportTop5.positive"
                            :assignPositive="true"
                            :onlyList="true"
                            timeKey="lastCreatedStr"
                            :noIndex="false"
                        ></ArticleList>
                    </div>

                </div>

                <div class="tip">
                    <p>{{ reportTip }}</p>
                </div>
            </div>
        </div>
        <ExportButton
            page="report"
            class="exportBtn text_c"
            :subject="subject"
            @handelPptAndImageData="handelPptAndImageData"/>
        <LoadingPage :loading="loading"/>
        <Toast v-if="!user" :text="toastText"/>
    </div>
</template>

<script>

import req from "@/util/request"
import _co from "@/util/const"
import common from "@/util/common"
import covertData from "@/util/covertData"
import _ from "loadsh"
import moment from "moment"
import CurveChart from "@/components/chart/CurveChart"
import HealthRank from "@/components/entity/HealthRank"
import PieChart from "@/components/chart/PieChart"
import TendencyPercentBar from "@/components/entity/TendencyPercentBar"
import BarChartCrosswise from "@/components/chart/BarChartCrosswise"
import TendencyChart from "@/components/chart/TendencyChart"
import MediaReports from "@/components/entity/MediaReports"
import ArticleList from "@/components/entity/ArticleList"
import HealthTable from "@/components/entity/HealthTable"
import SplitLine from "@/components/common/SplitLine"
import VerticalLine from "@/components/common/VerticalLine"
import SoundTrendChart from "@/components/chart/SoundTrendChart"
import ExportReportTitle from "@/components/common/ExportReportTitle"
import ExportButton from "@/components/common/ExportButton"
import utils from "@/util/common";



export default {
    name: 'ExportReport',
    components: {
        CurveChart,
        HealthRank,
        PieChart,
        BarChartCrosswise,
        TendencyChart,
        MediaReports,
        ArticleList,
        SplitLine,
        HealthTable,
        TendencyPercentBar,
        VerticalLine,
        SoundTrendChart,
        ExportReportTitle,
        ExportButton,
        EventStatsBar(render){ require(["@/components/entity/EventStatsBar"], render) },
        LoadingPage(render){ require(["@/components/common/LoadingPage"], render) },
        Toast(render){require(["@/components/common/Toast"], render)},

    },
    props: {},
    data() {
        return {
            user: common.getUser(),
            toastText:`<p>当前页面为“自助报告”样例示范，</p><p>注册会员后可生成定制版报告。</p>`,
            selected: 0,
            loading: true,
            reportNavList: [..._co.reportNavList],
            reportPeriodMap: _co.reportPeriodMap,
            reportYesPeriodMap: _co.reportYesPeriodMap,
            reportTip: _co.siteConfig.reportTip,
            entityType: "",
            entityId: "",
            title: "",
            timeStr: "",
            general: null,
            fameHealthTrend: null,
            subEntityHealth: null,
            riskStats: null,
            spreadStats: null,
            reportTop5: {},
            reportDesc: "",
            mainEvent: null,
            negChief: null,
            subCompanySpreadStats: null,
            healthTrendStr: "",
            broadcastEffectStr: "",
            riskGeneralStr: "",
            riskLevelStr: "",
            period:"",
            subject:"",
            periodStr: "",
            mainEventStr: "",
            soundTrendStr: "",
            soundTrends: [],
            allArticleCount: 0,//全部报道
            subjectArticleCount: 0, //主体报道
            negArticleCount:0,
            endTime: "",
            id: this.$route.params.id,
            reportStr: "敏感报道",
            unitStr: "篇",
            entityLabel: "企业",
        }
    },
    filters: {},
    mounted() {
        this.getData();
    },
    methods: {
        async getData() {
            this.loading = true;
            let res = await req.get(`/api/report/${this.$route.params.id}`);
            if(!res)
                return ;
            let {entityId, entityType, period, data, startTime, endTime} = res;
            let periodStr = this.reportPeriodMap[period];
            this.title = `${entityType === 'company' ? entityId: common.convertEntityName(entityId)}舆情${periodStr}报`;
            document.title = this.title;

            this.period = period;
            this.periodStr = periodStr;

            this.timeStr = common.dateStrRange(startTime, endTime);
            this.subject = `${period == "day" ? moment(startTime).format("YYYY年MM月DD日") : moment(endTime).format("YYYY年MM月")} ${ this.title}`;

            this.endTime = endTime;
            this.entityId = entityId;
            this.entityType = entityType;
            if (entityType === 'company' && periodStr === this.reportPeriodMap.month)
                this.reportNavList[this.reportNavList.length - 1] = "重大事件";

            if (entityType === 'industry') {
                this.reportStr = "敏感事件";
                this.unitStr = "件";
                this.entityLabel = "行业"
            }

            let {
                general,
                riskStats,
                spreadStats,
                articleCount,
                // articleCountYesterday,
                reportTop5,
                mainEvent,
                subjectArticleCount,
                allArticleCount
            } = data
            this.general = general;
            this.riskStats = riskStats;
            this.spreadStats = spreadStats;
            this.reportTop5 = reportTop5;
            this.negChief = entityType == "industry" ? _.get(reportTop5, "negative[0]", null) : general.mainNegChief;
            this.mainEvent = mainEvent;

            let str1 = '焦点报道';
            let str2 = '报道'

            if (period === 'month') {
                str1 = '重点事件';
                str2 = '事件'
            }

            this.reportDesc = `${common.formatDateStr(this.periodStr)}，${common.convertEntityNameStr(this.entityId, this.entityType)}`;
            if (reportTop5.negative.length === 0 && reportTop5.positive.length === 0) {
                this.reportDesc += `<b>暂无${str1}。</b>`
            } else {
                this.reportDesc += `${str1}中，`;
                if (this.reportTop5.negative.length > 0) {
                    let item = this.reportTop5.negative[0];
                    this.reportDesc += `敏感${str2}《<a href=${item.uri} class="co_333" target="_blank"><b>${item.title}</b></a>》的传播影响力最广，共涉原创及转载报道<b>${item.forwardCount}篇</b>，全网传播覆盖<b>${common.formatNumberWan(item.coveredPeopleCount || 0)}人次</b>`
                }
                if (this.reportTop5.positive.length > 0) {
                    if (this.reportTop5.negative.length > 0) {
                        this.reportDesc += `；`;
                    }
                    let item = this.reportTop5.positive[0];
                    this.reportDesc += `正面${str2}《<a href=${item.uri} class="co_333" target="_blank"><b>${item.title}</b></a>》的传播影响力最广，共涉原创及转载报道<b>${item.forwardCount}篇</b>，全网传播覆盖<b>${common.formatNumberWan(item.coveredPeopleCount || 0)}人次</b>`
                }
                this.reportDesc += `。`;
            }

            if(this.entityType == "company"){
                this.subjectArticleCount = _.sumBy(spreadStats.channelTendency, "total");
                this.allArticleCount = allArticleCount;
                this.negArticleCount = riskStats.negArticleCount
            } else{
                this.subjectArticleCount = subjectArticleCount || 0;
                this.allArticleCount = articleCount.total;
                this.negArticleCount = articleCount.negative;
            }

            //健康度趋势数据
            this.formatHealthTrentData(this.general.fameHealthTrend, general.industry, period);


            let riskLevel_I = _.get(riskStats, 'riskLevelCounts[0].count', 0);
            let riskLevel_II = _.get(riskStats, 'riskLevelCounts[1].count', 0);
            let highRiskLevelCount = riskLevel_I + riskLevel_II;

            //子行业健康度或者下属企业健康度列表
            this.formatSubEntityHealth(general.subIndustryHealth || riskStats.subCompanyHealth, spreadStats.subCompanyNegEvent);

            let {subCompaies, channelTendency} = spreadStats

            //传播影响力分布
            this.formatEffect(spreadStats, highRiskLevelCount);

            let {riskLevelCounts,  highRiskLevelEvents} = riskStats;

            //风险概述
            this.formatRiskStats(riskStats);

            //风险等级占比
            this.riskLevelPercent(riskLevelCounts, highRiskLevelEvents)

            //下属企业舆情分布
            this.subCompanyOpinion(subCompaies, channelTendency);

            //发文趋势
            if (mainEvent) {
                let {soundTrend} = mainEvent;
                this.soundTrends = soundTrend && soundTrend.list || [];
                this.soundTrendStr = `从${soundTrend.eventStartTime}至当前报告截止时间，该事件舆情报道总量为${soundTrend.total}篇（原创${soundTrend.original}篇，转发${soundTrend.forwarding || 0}篇），其中敏感报道${soundTrend.negative}篇，占比${common.formatPercent(soundTrend.negative, soundTrend.total)}%。最近一次声量峰值出现于${soundTrend.peakTime}，主要受${soundTrend.media}发文${soundTrend.title}的影响。`
            }

            this.loading = false;
        },
        formatSubEntityHealth(subEntityHealth = [], negEvent = null) {
            if (this.entityType == "company" && subEntityHealth && subEntityHealth.length > 0) {
                this.subEntityHealth = {
                    head: [
                        {name: '排名', key: 'indexNumber'},
                        {name: '企业', key: 'name'},
                        {name: '', key: 'value'},
                    ],
                    items: subEntityHealth,
                    title: "下属企业舆情健康指数",
                    content: !negEvent || subEntityHealth.length == 0 ? `${common.formatDateStr(this.periodStr)}，${this.entityId}下属企业舆情健康指数良好。` :
                        `${common.formatDateStr(this.periodStr)}，${this.entityType}下属企业${subEntityHealth[0].name}舆情健康指数最低，主要受《${subEntityHealth.title}》广泛传播影响。`
                };

            } else if (this.entityId === "金融业") {
                _.forEach(subEntityHealth, sub=>{
                    sub.name = common.convertEntityName(sub.name)
                })

                this.subEntityHealth = {
                    head: [
                        {name: '排名', key: 'indexNumber'},
                        {name: '行业', key: 'name'},
                        {name: '舆情健康指数', key: 'value'},
                    ],
                    items: _.orderBy(subEntityHealth, ["value", "name"], ["desc", "asc"]),
                    title: "子行业舆情健康指数",
                    content: `${common.formatDateStr(this.periodStr)}，${this.entityId}风险度最高子行业TOP5为：${_.orderBy(subEntityHealth, ["value", "name"], ["asc", "desc"]).slice(0, 5).map(item => item.name).join("，")}，需重点关注。`
                }
            }
        },
        formatHealthTrentData(data, industry = "", period) {
            // 需求改为计算7日均值时，全部按照最后一天的值，绘制一条直线
            // if (data.average) {
            //     const baseAvg = data.average[data.average.length - 1].value;
            //     data.average.forEach((e, index) => {
            //         data.average[index].value = baseAvg;
            //     });
            // }
            let target1 = data.each || data.company,
                target2 = data.average || data.industry;
            if (!target1 || !target1.length)
                return;

            this.fameHealthTrend = {
                target1: target1,
                target2: target2,
                labelData: [common.convertEntityName(this.entityId, this.entityType), this.entityType == "company" ? common.convertEntityName(industry) : "7日均值"]


            }
            let target1Len = target1.length, target2Len = target2.length;
            let today = _.get(this.fameHealthTrend, `target1[${target1Len - 1}].value`, 0),
                target2Today = _.get(this.fameHealthTrend, `target2[${target2Len - 1}].value`, 0);
                
            if(period == "month"){
                today = parseInt(_.sumBy(target1, "value") / target1Len);
                target2Today = parseInt(_.sumBy(target2, "value") / target2Len);
            }
            //相同时间，不用实体对比
            let targetDiff = today - target2Today,
            targetLabel = this.entityType == "company" ? "行业均值" : "7日均值";

            this.healthTrendStr = `${common.formatDateStr(this.periodStr)}，${common.convertEntityNameStr(this.entityId, this.entityType)}舆情健康指数为<b>${today}分</b>，`;

            if(this.allArticleCount > 0 && this.subjectArticleCount > 0){
                this.healthTrendStr = `${common.formatDateStr(this.periodStr)}，${common.convertEntityNameStr(this.entityId, this.entityType)}的舆情报道总量为<b>${this.allArticleCount}篇</b>，其中<b>${this.subjectArticleCount}篇</b>为主体性报道，其余为提及性报道。${this.subjectArticleCount ? "基于主体性报道数据，":""}综合测算得出${common.convertEntityName(this.entityId, this.entityType)}的舆情健康指数为<b>${today}分</b>，`;
            }

            if (targetDiff) {
                this.healthTrendStr += `${targetDiff > 0 ? '高于' : '低于'}${targetLabel}。`
            } else {
                this.healthTrendStr += `与${targetLabel}持平。`;
            }

            if (this.negChief){
                this.healthTrendStr += `对舆情健康指数产生影响的主要敏感事件为${common.covertHtmlLink(this.negChief)}`;
                if(this.entityType == "industry"){
                    let companies = this.negChief.companies || [];
                    let entitLength = companies.length;
                    this.healthTrendStr += entitLength > 1 ? `，该事件报道的主体为${companies[0].name}、${companies[1].name}${entitLength>2 ? '等。' :'。'}` : entitLength  ==1 ? `，该事件报道的主体为${companies[0].name}。`: `。`

                }else{
                    this.healthTrendStr += `。`;

                }
            }

        },
        formatEffect(spreadStats) {
            //传播影响力分布
            let {broadcastEffect, mainAffectEventByTendency, effectForwardCountsByTendency} = spreadStats;
            let data = _.filter(broadcastEffect, e => e.total > 0)
            let sumEvent = _.sumBy(data, 'total');

            this.broadcastEffectStr = `${common.formatDateStr(this.periodStr)}，${common.convertEntityNameStr(this.entityId, this.entityType)}正面、中性及敏感事件共<span class="font_b">${sumEvent}</span>件`;
            if (sumEvent > 0) {
                this.broadcastEffectStr += `，事件传播影响力等级最高为<span class="font_b">${common.getAE(data[0].level)}</span>级，涉及事件<span class="font_b">${data[0].total}</span>件，其中敏感事件<span class="font_b">${data[0].negative}</span>件`;
                let titleMap = _.keyBy(mainAffectEventByTendency, 'tendency')

                this.broadcastEffectStr += data[0].negative > 0 && titleMap['负面'] ? `，主要敏感事件为<a href=${titleMap['负面'].uri} class="co_333" target="_blank"><span class="font_b">《${titleMap['负面'].title}》</span></a>；` : `；`;

                this.broadcastEffectStr += `正面事件<span class="font_b">${data[0].positive}</span>件`;
                this.broadcastEffectStr += data[0].positive && titleMap['正面'] ? `，主要正面事件为<a href=${titleMap['正面'].uri} class="co_333" target="_blank"><span class="font_b">《${titleMap['正面'].title}》</span></a>。` : '。';
            } else {
                this.broadcastEffectStr += '。'
            }

            // 处理chart显示的事件数/文章数
            let effectForwardCounts = common.formmatArticleCountByAffect(effectForwardCountsByTendency);
            if (effectForwardCounts) {
                _.each(broadcastEffect, item => {
                    let info = _.find(effectForwardCounts, {key: item.level});
                    item.articleCount = info ? info.value : 0;
                });
            }
        },
        formatRiskStats(riskStats) {
            let {
                contentRisks,
                riskLevelCounts,
                yinbaoRiskCounts,
            } = riskStats;


            let riskCount = _.sumBy(riskLevelCounts, 'count');
            let riskGeneralStr = `${common.formatDateStr(this.periodStr)}，${common.convertEntityNameStr(this.entityId, this.entityType)}暂无敏感事件。`;
            if (riskCount) {
                riskGeneralStr = `${common.formatDateStr(this.periodStr)}，${common.convertEntityNameStr(this.entityId, this.entityType)}共发生敏感事件<b>${riskCount}件</b>。`;
                riskGeneralStr += utils.getRiskLabelStr(yinbaoRiskCounts, contentRisks, this.entityType)
            }
            this.riskGeneralStr = riskGeneralStr;
        },
        subCompanyOpinion(subCompaies = [], channelTendency = []) {
            `本月交通银行及其下属机构舆情总数80篇，其中交银金融租赁舆情总数最多达22篇，交银国际控股负面舆情数最多达6篇`

            if (this.entityType == "company" && subCompaies && subCompaies.length > 0) {
                let total = _.sumBy(subCompaies, 'total') + _.sumBy(channelTendency, 'total');
                let arr = _.orderBy(subCompaies, ['negative'], ['desc']);

                this.subCompanySpreadStats = {
                    heads: [
                        {key: 'negative', label: '负面传播'},
                        {key: 'neutral', label: '中性传播',},
                        {key: 'positive', label: '正面传播'},
                    ],
                    items: subCompaies,
                    title: "下属企业舆情分布",
                    content: subCompaies.length == 0 ? `${common.formatDateStr(this.periodStr)}，${this.entityId}及其下属机构舆情总数<b>${total}篇</b>。` :
                        `${common.formatDateStr(this.periodStr)}${this.entityId}及其下属机构舆情总数<b>${total}篇</b>，其中${subCompaies[0].name}舆情总数最多达<b>${subCompaies[0].total}篇</b>，${arr[0].name}舆情数最多达<b>${arr[0].negative}篇</b>。`
                };

            }
        },
        riskLevelPercent(riskLevelCounts, highRiskLevelEvents) {
            let riskLevelStr = `${common.formatDateStr(this.periodStr)}，暂无敏感事件。`
            let riskCount = _.sumBy(riskLevelCounts, 'count'); // 今日风险等级总计

            if (riskCount) { // 敏感事件 不为 0 时
                riskLevelStr = utils.getRiskLevelContent(this.periodStr, this.entityId, riskLevelCounts, highRiskLevelEvents, this.entityType);
            }
            this.riskLevelStr = riskLevelStr;
        },
        async handelPptAndImageData(){
            let sendEmailPptData = sessionStorage.getItem("sendEmailPptData");
            let imageData = sessionStorage.getItem("imageData");
            if(!sendEmailPptData)
                this.handelPptData()

            if(!imageData)
                this.canvasImage()
        },
        async handelPptData(){

            let {list: effectArr} = this.$refs.broadcastEffectRef;
            // let {listData} = this.$refs.percentBarRef;
            let {heads: yinbaoHeads, riskArr: yinbaoRiskArr, total: yinbaoTotal, headPerStr: yinbaoHeadPerStr} = this.$refs.yinbaoRiskRef;
            let {heads: contentHeads, riskArr: contentRiskArr,  total: contentTotal, headPerStr: contentHeadPerStr} = this.$refs.contentRiskRef;
            let {list: riskLevelArr} = this.$refs.riskLevelRef;
            let {content: tendencyStr, list: tendencyArr} = this.$refs.tendencyChartRef;
            let {content:mediaReportStr, list: medias} = this.$refs.mediaReportRef;

            // let cloneBroadcastEffect = this.spreadStats.broadcastEffect;
            let charts = [
                {
                    "id_name": "rep_title1",
                    "type": "text",
                    "data": `${common.convertEntityName(this.entityId, this.entityType)}舆情`
                },
                {
                    "id_name": "rep_time",
                    "type": "text",
                    "data": this.timeStr
                },
                {
                    "id_name": "rep_title2",
                    "type": "text",
                    "data": `${this.periodStr}报`
                },
                covertData.healthTrendData_ppt(_.extend({text: this.healthTrendStr}, this.fameHealthTrend)),
                covertData.pieData_ppt({
                    title: this.entityType === "company" ? "1·2 传播影响力分布" : ~["金融", "金融业"].indexOf(this.entityId) ? "1·4 传播影响力分布" : "1·3 传播影响力分布",
                    text: this.broadcastEffectStr,
                    list: effectArr
                }),
                covertData.effectTendencyBar_ppt({list: this.spreadStats.broadcastEffect}),
                covertData.effectTendencyTable_ppt({list: this.spreadStats.broadcastEffect}),
                covertData.riskTable_ppt({text: this.riskGeneralStr, heads: yinbaoHeads, list: yinbaoRiskArr}),//银保风险标签
                covertData.riskTable_ppt({
                    id_name:"p2_2_fengxkeywords_table",
                    title: "2·2 主要内容风险点",
                    heads: contentHeads,
                    list: contentRiskArr,
                    riskType:"contentRisk",
                }),//内容风险标签
                covertData.riskBar_ppt({
                    id_name: "p2_1_fengx10_bar",
                    list: yinbaoRiskArr,
                    heads: _.cloneDeep(yinbaoHeads).concat(["总数"]),
                    total: yinbaoTotal,
                }),
                covertData.riskBar_ppt({
                    id_name:"p2_2_fengxkeywords_bar",
                    list: contentRiskArr,
                    heads: _.cloneDeep(contentHeads).concat(["总数"]),
                    total:contentTotal,
                }),
                covertData.pieData_ppt({
                    id_name: "p2_3_fxzhanbi_pie",
                    title: "2·3 风险等级占比",
                    text: this.riskLevelStr,
                    list: riskLevelArr,
                    unit:"件"
                }),
                covertData.tendenyBar_ppt({
                    text:`${tendencyStr}${medias.length ?  mediaReportStr : ""}`,
                    list: tendencyArr,
                    heads: [ " ", "敏感报道", "中性报道", "正面报道", "报道量（篇）" ]
                }),
                covertData.mediaTable_ppt({
                    list: medias,
                }),
                covertData.moduleStr_ppt({
                    id_name: "media_tendency_percent_title",
                    type: "text",
                    data: "敏感舆情总量中占比"
                }),
                covertData.mediaBar_ppt({
                    list: medias,
                    total: _.sumBy(this.spreadStats.channelTendency, "negative")
                }),
                covertData.mediaPercent_ppt({
                    list: medias,
                }),
                covertData.moduleStr_ppt({
                    id_name: "p2_menu_item2",
                    data: "2. 主要内容风险点"
                }),
                covertData.moduleStr_ppt({
                    id_name:"p2_1_fengx10_percent_text",
                    data: yinbaoHeadPerStr
                }),
                covertData.moduleStr_ppt({
                    id_name:"p2_2_fxkeywords_perc_text",
                    data: contentHeadPerStr
                }),
                covertData.moduleStr_ppt({
                    id_name:"btm_fengx10_intro",
                    data: _co.yinbaoRiskDesc
                }),
                covertData.moduleStr_ppt({
                    id_name:"btm_fxkeywords_intro",
                    data: _co.contentRiskDesc
                }),

            ]


            //企业月报 - 重点事件
            if (this.entityType === "company" && this.periodStr === this.reportPeriodMap.month) {

                //重点事件-图片
                covertData.htmlTocanvas(this.$refs.companyNegImage).then(data => {
                    charts.push(covertData.canvaImage_ppt({"id_name": "p4_sensitive_picture", data, text: this.reportDesc}))
                })
                covertData.htmlTocanvas(this.$refs.companyPosImage).then(data => {
                    charts.push(covertData.canvaImage_ppt({"id_name": "p4_positive_picture", data, text: this.reportDesc}))
                })

                // covertData.htmlTocanvas(this.$refs.mainEventImage).then(data => {
                //     charts.push(covertData.canvaImage_ppt({"id_name": "qym_p4_sjgy_picture", title: "4·1 事件概要", data}))
                // })

                //发文趋势
                charts.push(covertData.soundTrendChart_ppt({text: this.soundTrendStr, list: this.soundTrends}));
            }else{

                //近期报道
                covertData.htmlTocanvas(this.$refs.negImage).then(data => {
                    charts.push(covertData.canvaImage_ppt({"id_name": "p4_sensitive_picture", data, text: this.reportDesc}))
                })
                covertData.htmlTocanvas(this.$refs.posImage).then(data => {
                    charts.push(covertData.canvaImage_ppt({"id_name": "p4_positive_picture", data, text: this.reportDesc}))
                })
            }


            if(this.entityType == "industry" ){
                let {content: companyHealthStr, renderData} = this.$refs.healthRankRef;

                charts.push(covertData.companyHealthContent_ppt({text: companyHealthStr}));
                charts.push(...covertData.companyHealthData_ppt(renderData));

                //企业健康度指数分布
                charts.push(covertData.companyHealthStr_ppt({entity: this.entityId}));

                charts.push(...covertData.companyHealthLabel_ppt(this.general.companyCounts.list));

                if(this.entityId === "金融业"){
                    //子行业健康度
                    charts.push(covertData.subEntityHealth_ppt(_.extend(this.subEntityHealth, {title: "1·2 子行业舆情健康指数"})));
                }
            }

            let pptData = {
                // "name": "数据报表",
                "template": `${this.title}${this.period == "day" ? moment(this.endTime).format("YYYYMMDD") :""}.pptx`,
                // "report_title":`${this.title}`,//文件名
                "pptcode": covertData.getReportPptCode(this.entityType, this.entityId, this.period),
                "charts": charts,
                // "articles": [],
                "customer": {
                    "code": "xinhua",
                    "name": "xinhua"
                },
                "project": {
                    "code": "xinhua",
                    "name": "xinhua"
                }
            }
            setTimeout( ()=>{
                // console.log("pptData:",JSON.stringify(pptData), charts)
                sessionStorage.setItem('sendEmailPptData', JSON.stringify(pptData));

            },1000)
        },
        canvasImage(){
            //生成报告图片
            let _self = this;
            setTimeout(()=>{
                covertData.htmlTocanvas(_self.$refs[`reportBox`]).then(data => {
                    sessionStorage.setItem('imageData', JSON.stringify({data}));
                })
            },1000)

        }
    }

}
</script>

<style lang="scss" scoped>

.export_report_box {
    position: relative;
    font-family: PingFangSC-Regular, PingFang SC;

    .header {
        width: 100%;
        height: 84px;
        background: url("../assets/img/report/headerBg.png") no-repeat center;
        background-size: 100%;
        position: relative;
        text-align: center;

        .title {
            width: 375px;
            position: absolute;
            top: 8px;
            left: 50%;
            margin-left: -187.5px;
            letter-spacing: 0;
            line-height: 32px;
        }

        .time {
            font-family: PingFangSC-Regular;
            width: 100%;
            position: absolute;
            bottom: 8px;
        }

    }

    .report_body {
        .nav {
            font-size: 16px;
            height: 52px;
            line-height: 52px;
            border: 0.1px solid #EDEDED;

            section {
                width: 33.33%;
                text-align: center;
                position: relative;

                .subLine {
                    width: 48px;
                    height: 3px;
                    background-color: rgba(3, 57, 159, 1);
                    border-radius: 10px;
                    position: absolute;
                    bottom: 0;
                    left: calc( (100% - 47px) / 2 );
                    display: none;
                }
            }

            .active {
                color: rgba(51, 51, 51, 1);
                font-weight: bold;

                .subLine {
                    display: inline-block
                }
            }
        }
    }

    .view_port_box {
        // min-height: calc(100vh - 136px);
    }

    .data_box {
        min-height: calc(100vh - 160px);
        padding-bottom: 60px;
    }

    ._box {
        padding: 0px 16px;

        &.noRight {
            padding-right: 0;
        }
    }

    .tip {
        min-height: 32px;
        margin-top: 48px;

        p {
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: #666666;
            letter-spacing: 0;
            line-height: 16px;
            font-weight: 400;
            padding: 0 16px 0 16px;
            position: absolute;
            bottom: 65px;
        }
    }
    .exportBtn {
      position: fixed;
      left: 0;
      bottom: 0;
      width: 100%;
    }

  .top_desc {
    padding: 0 20px;
    margin-bottom: 20px;
  }
}
</style>
